/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Runs_SeatInputs */

const en_mk_mx_runs_seat = /** @type {(inputs: Mk_Mx_Runs_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra tasks per seat`)
};

const id_mk_mx_runs_seat = /** @type {(inputs: Mk_Mx_Runs_SeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahan tugas per kursi`)
};

/**
* | output |
* | --- |
* | "Extra tasks per seat" |
*
* @param {Mk_Mx_Runs_SeatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_runs_seat = /** @type {((inputs?: Mk_Mx_Runs_SeatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Runs_SeatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_runs_seat(inputs)
	return en_mk_mx_runs_seat(inputs)
});